import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 7,
	height: 7,
	viewBox: "0 0 7 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.73958 6.70833V2.36458L0.875 4.22917L0 3.35417L3.35417 0L6.70833 3.35417L5.83333 4.22917L3.96875 2.36458V6.70833H2.73958Z",
		fill: "white"
	})
});
export default SvgUpArrow;
